<template>
  <div class="calendar">
    <ClientOnly>
      <VDatePicker 
        v-model.string="calDate" 
        is-required 
        :locale="locale"
        :min-date="$dayjs().add(-2, 'years').format('YYYY-MM-DD')"
        :max-date="$dayjs().add(120, 'days').format('YYYY-MM-DD')"
        :attributes="attrs" 
        :masks="{ modelValue: 'YYYY-MM-DD' }" 
        :onchange="onChange()"
      />
    </ClientOnly>
    <div class="debug my-2">
      calDate: {{ calDate }}
      <br>
      route: {{ route.query?.date }}
    </div>
  </div>
</template>

<script setup lang="ts">
const locale = useEnv('locale')
const dayjs = useDayjs()
const route = useRoute()
const router = useRouter()
const calDate = ref((route.query?.date || route.query?.startDate) || dayjs().format('YYYY-MM-DD'))

const attrs = ref([
  {
    key: 'today',
    dot: true,
    dates: new Date()
  }
])

// Push route on change, if route date is not in sync with calendar
const onChange = () => {
  console.log('onChange', calDate.value)
  console.log('today', dayjs(calDate.value).isToday())

  // if (!dayjs(calDate.value).isToday() && !route.query?.date && route.query?.date !== calDate.value) {
  //   useUpdateQuery({
  //     date: calDate.value,
  //     startDate: undefined,
  //     endDate: undefined,
  //   })
  // }
}

// Watch changes in cal date to update query
watch(() => calDate.value, () => {
  console.log('watch calDate', calDate.value)

  // useUpdateQuery({
  //   date: calDate.value,
  //   startDate: undefined,
  //   endDate: undefined,
  // })
  
  // router.push({ query: {
  //   ...route.query,
  //   date: calDate.value,
  //   startDate: undefined,
  //   endDate: undefined,
  // }})
})
</script>

<style lang="scss" scoped>
.calendar {
  &:deep(.vc-container) {
    @apply bg-transparent;
  }

  &:deep(.vc-bordered) {
    @apply border-0 w-full; 
  }

  &:deep(.vc-header) {
    @apply text-base p-0 m-0;
  }

  &:deep(.vc-header .vc-arrow) {
    @apply text-coral;
  }

  &:deep(.vc-header .vc-arrow:hover) {
    @apply bg-transparent;
  }
  
  &:deep(.vc-weekday) {
    @apply text-black opacity-60 text-xs font-medium;
  }

  &:deep(.vc-weeks) {
    @apply p-0;
  }

  &:deep(.vc-dot) {
    @apply bg-coral;
  }

  &:deep(.vc-day-content) {
    @apply transition-all;
  }

  &:deep(.vc-day-content:hover:not(.vc-highlight-content-solid)) {
    @apply bg-mist;
  }

  &:deep(.vc-highlight-bg-solid), 
  &:deep(.vc-day-content:hover) {
    @apply bg-coral;
  }

  &:deep(.vc-focus) {
    @apply shadow-none;
  }

  &:deep(.vc-nav-item.is-active) {
    @apply bg-coral;
  }
}
</style>